<template>
  <b-container ref="appBox">
      <!-- loader -->
    <div class="text-center overlay"  v-if="waitMaterials && apiUp">
        <div>
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </div>
    <!-- api down message -->
    <b-row>
      <b-col>
        <b-alert variant="danger" :show="apiDown">
            The cost estimator is not available. Please contact the site administrator.
        </b-alert> 
      </b-col>
  </b-row>
    <!-- form -->
    <b-row>
    <b-col cols="12" v-if="apiUp">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">  
     <b-form @submit.stop.prevent="handleSubmit(submitForm)"> 
    <!-- <b-form @submit.prevent="submitForm" > -->
        <validation-provider name="Material" :rules="{ required: true }" v-slot="validationContext">
            <b-form-group id="input-material" label="Material Type" label-for="material">
                <b-form-select
                id="material"
                v-model="form.material"
                :options="materials"
                v-on:change="changeMaterial($event)"
                :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback id="input-material">Material is required</b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>
        <b-alert dismissible fade v-model="helperText">
            <div class="float-left" style="margin-top:5px;"><b-icon icon="info-circle" aria-hidden="true"></b-icon></div>
            <p id="weightHelp" class="form-text" v-html="weightHelp" style="margin-left:25px;"></p> 
        </b-alert> 

        <b-form-group id="input-unit" label="Number of Units" label-for="unit" v-if="materialInUnits">
            <b-form-select
            id="unit"
            v-model="form.unit"
            :options="units"
            required
            ></b-form-select>
            <small id="unitsHelp" class="form-text text-muted"></small>
        </b-form-group>

        <validation-provider name="Weight" :rules="{ required: validateWeight ? true : false, isNum: true, min_value: 0.00001, max_value: validateMax ? max_weight : false}" v-slot="validationContext">
  
            <b-form-group id="input-weight" label="Estimated Weight" label-for="weight"  v-if="weights">
                <b-form-input
                id="weight"
                v-model="form.weight"
                :state="getValidationState(validationContext)"
                v-on:keypress="isNumber($event)"
                @focus="hideResults()"
                ></b-form-input>
                <b-form-invalid-feedback id="input-weight">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>

        <b-form-group label="Unit of Measure" label-for="uom" v-slot="{ ariaDescribedby }" v-if="weights">
            <b-form-radio-group
                id="uom"
                v-model="form.uom"
                :options="uom"
                :aria-describedby="ariaDescribedby"
                name="uom"
                v-on:change="validateMaxWeight();"
            ></b-form-radio-group>
        </b-form-group>

        <b-button type="submit" variant="primary" v-if="calculate">
           Estimate Cost 
        </b-button>
     </b-form>
      </validation-observer>
    </b-col>
  </b-row>
  <br/>
  <b-row>
      <b-col>
        <b-alert variant="success" :show="result">
            <strong>Estimated Cost:</strong> <br/>
            <span v-html="cost" class="dollar"></span>
            <div v-html="redirectMsg"></div>
        </b-alert> 
      </b-col>
  </b-row>
  <!-- <b-row>
      <b-col>
        <b-alert variant="secondary" :show="result">
            <h5 class="alert-heading">For testing only</h5>
            <p>
                This section will be removed for production.
            </p>
            <hr>
            <p>Entered weight: {{this.form.weight}} {{selected_uom}}</p>
            <p>Converted weight to KG: {{entered_kg}}</p>
            <p>Round to nearest 5KG: {{rounded_kg}}</p>
        </b-alert> 
      </b-col>
  </b-row> -->
  </b-container>
</template>

<script>

var materials = [
    { text: 'Select One', value: null }
];

var all_materials = [];
var maxWeightMaterials = [];
var priceCeilingMaterials = [];
var unit_cost = 0;

import axios from 'axios'
// const baseURL = 'https://localhost:44364'

//   const config = {
//     baseURL: baseURL,
//     headers: {
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Allow-Headers': '*',
//       'Access-Control-Allow-Methods': 'POST',
//     }
//   }
//  const request = axios.create(config);


         



import { extend } from 'vee-validate';
export default {
  name: "Calculator",
  props: {
    msg: String
  },
  data: () => ({
        form: {
          weight: '',
          material: null,
          unit: 1,
          uom: '2205',
        },
        materials: materials,
        units: ['1', '2', '3', '4'],
        uom: [
          { text: 'Pounds', value: '2205' },
          { text: 'Kilograms', value: '1000' },
          { text: 'Tonnes', value: '1' }, 
        ],
        result: false,
        materialInUnits: false,
        weights: false, 
        calculate: true,
        cost: '',
        redirectMsg: '',
        weightHelp: '' ,
        helperText: false,
        validateWeight: true,
        validateMax: false,
        max_weight: 0,
        entered_kg: 0,
        waitMaterials: true,
        apiDown: false,
        apiUp: true,
        //for testing display
        rounded_kg: 0,
        selected_uom: ''
    
  }),
  created: function () {
             
      axios.get('/Materials/GetMaterials')
      //request.get('/Materials/GetMaterials')
        .then((response)  => {
            if (response.data) {
                this.waitMaterials = false;
                all_materials = JSON.parse(JSON.stringify(response.data));

                //console.table(all_materials);
                
                //load material dropdown
                all_materials.forEach(material => {
                    materials.push({text: material.name, value: material.id});
                });
                //materials with max weight
                all_materials.forEach(material => {
                    if(material.hasMaxWeight && !material.hasCeiling){
                        maxWeightMaterials.push({materialId: material.id, text: material.name, max: material.rates[0].maxWeight, message: material.maxWeightMessage});
                    }    
                });

                //materials with price ceilings based on weight
                all_materials.forEach(material => {
                    if(material.hasCeiling){
                        priceCeilingMaterials.push({materialId: material.id, text: material.name});
                    }    
                });
               
            }
          
        })
        .catch((error) => {
            this.apiDown = true;
            this.apiUp = false;
            console.log(error.message);
        });
        
  },
  methods: {
    changeMaterial: function(event) {
        
        var materialId = event;
       
        //reset weight input
        this.form.weight = '';
        this.$refs.observer.reset();

        if(materialId == null){
           this.resetForm();
        } else{
            var material_obj = all_materials.find(o => o.id == materialId);
            var material = material_obj.name;

            if(material_obj.costInUnits){
                //example: Mattress/Box Spring
                this.materialInUnits = true;
                this.weights = false;
                this.result = false;
                this.calculate = true;
                this.validateWeight = false;
                this.validateMax = false;
                
                this.weightHelp = '';
                this.redirectMsg = '';

                //Get helper message from materials array
                if(material_obj.message != null){
                    this.weightHelp = material_obj.message;
                    this.helperText = true;
                }else{
                    this.helperText = false;
                }
            
            } else if(material_obj.isFree){
                //FREE Items
                this.result = true;
                this.materialInUnits = false;
                this.weights = false;
                this.calculate = false;
                this.helperText = false;
                this.cost = "Free"
                this.weightHelp = '';
                //Get message from Free items array
                this.redirectMsg = material_obj.message;
                

                //POST result to API
                axios.post('/Estimates/CreateEstimate', {
                //request.post('/Estimates/CreateEstimate', {
                    material: material,
                    materialId: materialId,
                    uom: null,
                    convertedKg: 0,
                    units: 0,
                    result: 0,
                    weightEntered: 0,
                    roundedKg: 0
                })
                .then((response)  => {
                    if (response.data) {
                        //show result div
                        this.result = true;
                        console.log(response);
                    }
                })
                .catch((error) => {
                    console.log(error.message);
                });
            
            } else {
                //All other materials that can be estimated by weight
                this.materialInUnits = false;
                this.weights = true;
                //Get helper message from materials array
                if(material_obj.message != null){
                    this.weightHelp = material_obj.message;
                    this.helperText = true;
                }else{
                    this.helperText = false;
                }
                
                this.validateMaxWeight(material);

                //this.form.weight = null;
                this.calculate = true;
                this.result = false;
                this.cost = "";
                this.redirectMsg = '';
            }
        }

        	
        this.$nextTick(() => {
            let message = { height: this.$refs.appBox.clientHeight + 100};
            //console.log(this.$refs.appBox.clientHeight);
            // window.top refers to parent window
            window.top.postMessage(message, "*");
        });
   
               

    },
    hideResults: function (){
        this.result = false;
    },
    validateMaxWeight: function() {
        var measurement = this.form.uom;

        var maxweight_material = maxWeightMaterials.find(o => o.materialId == this.form.material);

        if(maxweight_material !== undefined){
            //turn on max weight validation
            this.validateWeight = true;
            this.validateMax = true;
            //get max weight value
            var maxweight_value = maxweight_material.max;
            //get validation message
            var error_message = maxweight_material.message;
            //set max value
            this.max_weight = maxweight_value * measurement;
            //console.log("max weight = " + this.max_weight);
            
            //update error message
            extend('max_value', {
                message: error_message
            });
 
        }else{
            this.validateWeight = true;
            this.validateMax = false;
        }
        
        this.result = false;
    
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();        
      } else {
        return true;
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    uomTotext(uom){
        var uom_text = '';
        if(uom == '2205'){
            uom_text = 'pounds'
        }
        if(uom == '1'){
            uom_text = 'tonnes'
        }
        if(uom == '1000'){
            uom_text = 'kilograms'
        }
        return uom_text;
    },
    round5Kg(x, uom){
        var toKg = 0;
        //convert x to kg
        if(uom == '2205'){
            toKg = x / 2.205;
            //for testing display
            this.selected_uom = 'Pounds';
        }
        if(uom == '1000'){
            toKg = x; 
            //for testing display
            this.selected_uom = 'Kilogram';
        }
        if(uom == '1'){
            toKg = x * 1000; 
            //for testing display
            this.selected_uom = 'Tonnes';
        }
     
        //for testing display
        this.entered_kg = toKg;
        this.rounded_kg = (toKg % 5) >= 2.5 ? parseInt(toKg / 5) * 5 + 5 : parseInt(toKg / 5) * 5;

        return (toKg % 5) >= 2.5 ? parseInt(toKg / 5) * 5 + 5 : parseInt(toKg / 5) * 5;
    },
    submitForm () {
        var estimate = 0;
        //var entered_weight = 0;
        var rounded_weight = 0;
        var entered_unit = 0;
        var entered_uom = '';
        var materialId = this.form.material;
        var material = materials.find(o => o.value == materialId);
        material = material.text;

        var material_obj = all_materials.find(o => o.id == materialId);
   
        //console.table(material_obj);

        //Per unit cost materials
        if(material_obj.costInUnits){
            entered_unit = this.form.unit;
            //entered_weight = 0;
            rounded_weight = 0;
            entered_uom = 'units';
            
            var costInUnits_rates = material_obj.rates[0];
            //get per unit cost
            var per_unit_cost = costInUnits_rates.rate;
            estimate = per_unit_cost * entered_unit;
        
        //materials with tiered pricing
        } else if(material_obj.hasCeiling){ 
            //get entered weight convert to kg and round to nearest 5kg
            rounded_weight = this.round5Kg(this.form.weight, this.form.uom);
            //convert kg to tonnes for calculation
            rounded_weight = rounded_weight / 1000; 
            //get array of rates
            var ceiling_obj = material_obj.rates;

            //get largest minimum load
            var largest_min_load = Math.max.apply(Math, ceiling_obj.map(function(o) { return o.minimumLoad; }))

            if(rounded_weight < largest_min_load){
                ceiling_obj = ceiling_obj.filter(o => o.minimumLoad <= rounded_weight && o.maximumLoad >= rounded_weight);
                //console.table(ceiling_obj);
                unit_cost = ceiling_obj[0].rate;
                estimate = unit_cost * rounded_weight;
                //check for ceiling
               // console.log(estimate);
                estimate = (estimate > ceiling_obj[0].costCeiling) ? ceiling_obj[0].costCeiling : estimate;
                //check for minimum charge
                estimate = (estimate < ceiling_obj[0].minimumFee) ? ceiling_obj[0].minimumFee : estimate;
                //add transaction fee
                estimate = estimate + ceiling_obj[0].transactionFee;
                //console.log(estimate);
                //under $25 message
                if(Math.round(estimate) < 25){
                    this.redirectMsg = "Loads received between 10:00 am - 2:00 pm on weekdays at North Shore, North Surrey, or United Boulevard recycling and waste centres have a $25 minimum fee.";
                }else{
                    this.redirectMsg = '';
                }
            } else {
                //no celings
                ceiling_obj = ceiling_obj.filter(o => o.maximumLoad == 0);
                //console.table(ceiling_obj);
                unit_cost = ceiling_obj[0].rate;
                estimate = unit_cost * rounded_weight;
                //add transaction fee
                estimate = estimate + ceiling_obj[0].transactionFee;
                this.redirectMsg = "";
            }

            //set unit to 0
            entered_unit = 0;
            //convert uom to text
            entered_uom = this.uomTotext(this.form.uom);
            
   
        }else{
            //get entered weight convert to kg and round to nearest 5kg
            rounded_weight = this.round5Kg(this.form.weight, this.form.uom);
            //convert kg to tonnes
            rounded_weight = rounded_weight / 1000; 
            //get material's rates object
            var obj_rates = material_obj.rates[0];
            //calculate cost per tonne
            estimate = obj_rates.rate * rounded_weight;
            //check for minimum charge
            estimate = (estimate < obj_rates.minimumFee) ? obj_rates.minimumFee : estimate;
            //add transaction fee
            estimate = estimate + obj_rates.transactionFee;
            //convert uom to text
            entered_uom = this.uomTotext(this.form.uom);
        }

        //round estiamte to nearest dollar
        estimate = Math.round(estimate);

        //get rounded weight in Kg
        rounded_weight = this.round5Kg(this.form.weight, this.form.uom);

        var input_weight = 0
        if(this.form.weight != '')
        {
            input_weight = this.form.weight;
        }
        var kg_weight = 0
        if(this.entered_kg != '')
        {
            kg_weight = this.entered_kg;
        }
        //POST result to API
        axios.post('/Estimates/CreateEstimate', {
        //request.post('/Estimates/CreateEstimate', {
            material: material,
            materialId: materialId,
            uom: entered_uom,
            convertedKg: kg_weight,
            weightEntered: input_weight,
            roundedKg: rounded_weight,
            units: entered_unit,
            result: estimate,
            
            //datetime: new Date().toISOString()
        })
        .then((response)  => {
            if (response.data) {
                //show result div
                this.result = true;
                console.log(response);
            }
        })
        .catch((error) => {
            console.log(error.message);
        });

        //show result
        this.cost = "$" + estimate.toLocaleString('en-US');
        this.result = true;

        this.$nextTick(() => {
            let message = { height: this.$refs.appBox.clientHeight + 50};
            //console.log(this.$refs.appBox.clientHeight);
            // window.top refers to parent window
            window.top.postMessage(message, "*");
        });
        
    },
    resetForm: function() {
        //form values
        this.form.uom = '2205';
        this.form.weight = null;
        this.form.unit = '1';
 

        //hide show reset
        this.calculate = true;
        this.result = false;
        this.materialInUnits = false;
        this.weights = false;
        this.redirectMsg = '';
        this.weightHelp = '';
        this.helperText = false;
        this.validateWeight = true;
        this.validateMax = true;

         this.$nextTick(() => {
            this.$refs.observer.reset();
        });
    },
  }
};


</script>